export const DEVICE_FORMATION_TYPES = {
  STANDARD: [
    116, 112, 111, 108, 104, 102, 106, 117, 107, 103, 101, 105, 110, 109, 118, 120
  ],
  DUAL_TORSO: [207, 203, 201, 205, 217],
  TMX450: [303, 301],
  TMX500: [700],
  GRIDLINK: [401],
  WEARABLE: [500],
  PPTOX: [600]
}

export const DEVICE_FORMATION_TYPE_ID = {
  STANDARD: 1,
  DUAL_TORSO: 2,
  TMX450: 3,
  GRIDLINK: 4,
  WEARABLE: 5,
  PPTOX: 6,
  TMX500: 7
}

export const BOARD_TYPE_NAME = {
  1: 'Tait Mobile 9300',
  2: 'Tait Portable 9300',
  3: 'Tait Mobile 9400',
  4: 'Tait Portable 9400',
  5: 'Tait Mobile 9100',
  6: 'Tait Portable 9100',
  7: 'Tait Mobile 9480',
  8: 'Tait Portable 9480',
  9: 'Harris XG Series',
  10: 'Harris XL Series',
  11: 'Tait Portable 9500',
  12: 'Tait Portable 9600',
  13: 'Tait Unified Vehicle 2.0',
  14: 'Tait Wearable',
  15: 'Android Device',
  16: 'Tait Portable 9800',
  17: 'Tait Mobile 9800',
  18: 'Tait Portable 9700',
  19: 'Tait Mobile 9700',
  20: 'Tait Portable 9900',
  21: 'Tait Mobile 9900'
}

export enum FIELD_TYPE {
  'NUMBER',
  'TEXT',
  'LIST',
  'MULTILINE',
  'PASSWORD'
}
